module.exports = __webpack_public_path__ + "img/flags/NZ.c045ba5.png";